import { gettext } from '@eventbrite/i18n';

export const MAKE_SURE_YOU_GET_PAID = gettext('Make sure you get paid');
export const SET_UP_YOUR_ACCOUNT = gettext(
    'Finish setting up your account to receive funds for your events.',
);
export const ADD_FINANCIAL_INFO_TO_GET_PAID = gettext(
    'Add your financial information to receive funds from your event',
);
export const ADD_BANK_INFO_TO_GET_PAID = gettext(
    'Set your bank account to receive funds from your event',
);
export const CASH_OUT_DAYS_LIMIT = 50;
export const ONE_DAY_IN_MILLIS = 24 * 60 * 60 * 1000;
